import { assert } from '@ember/debug';

import ApplicationAdapter from './application';

export default class InviteSignInFieldAdapter extends ApplicationAdapter {
  urlForQuery(
    query: { inviteId?: string; [key: string]: unknown },
    _modelName: Parameters<ApplicationAdapter['urlForQuery']>[1],
  ): string {
    assert('invite-sign-in-field adapter requires inviteId in query', query.inviteId);

    const inviteId = query.inviteId;
    delete query.inviteId; // Remove from query params
    // Build URL: /a/visitors/api/v3/invites/:id/sign-in-fields
    return `/${this.namespace}/invites/${inviteId}/sign-in-fields`;
  }
}
